import {
  CHANGE_DISPLAY_NAME_ERROR,
  RESET_CHANGE_DISPLAY_NAME_OBJ,
  RESET_CHANGE_DISPLAY_NAME_STATUS,
  CHANGE_DISPLAY_NAME,
  CHANGED_DISPLAY_NAME,
} from "./actionTypes";

const initialState = {
  status: {},
  data: {},
};

const ChangeDisplayName = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_DISPLAY_NAME_ERROR:
      state = {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            error: {
              status: true,
              message: action?.payload?.message,
            },
            loading: false,
            success: false,
          },
        },
      };
      break;
    case RESET_CHANGE_DISPLAY_NAME_OBJ:
      state = initialState;
      break;
    case RESET_CHANGE_DISPLAY_NAME_STATUS:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload]: null,
        },
      };
      break;
    case CHANGE_DISPLAY_NAME:
      state = {
        ...state,
        data: action.payload,
        status: {
          ...state?.status,
          change_display_name: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case CHANGED_DISPLAY_NAME:
      state = {
        ...state,
        status: {
          change_display_name: {
            error: false,
            loading: false,
            success: {
              status: true,
              chatId: action?.payload?.chatId,
              chatDisplayName: action?.payload?.chatDisplayName,
            },
          },
        },
      };
      break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default ChangeDisplayName;
